export default __webpack_public_path__ + "static/media/icons.38c6d8ba.woff2";